export const pokemonAPI = "https://pokeapi.co/api/v2";
export const pokemonRoute = `${pokemonAPI}/pokemon?limit=200`;
